import 'lazysizes'
import 'lazysizes/plugins/native-loading/ls.native-loading'
import 'whois-theme/ts/browser-update'
import 'whois-theme/ts/routes/search-banner'
import 'whois-theme/ts/routes/mobile-menu'

const path = window.location.pathname

switch (path) {
    case "/videos/":
        import('whois-theme/ts/routes/videos.js')
        break

    case "/":
        import('whois-theme/ts/routes/home.js')
        break
}

if (document.querySelector('whois-captcha-form') != null) {
    import('whois-theme/ts/components/captcha-form.js')
}

if (document.querySelector('whois-search') != null) {
    import('whois-theme/ts/components/search.js')
}

if (document.querySelector('whois-clamp-box') != null) {
    import('whois-theme/ts/components/clamp-box.js')
}

if (document.querySelector('video') != null) {
    import('whois-theme/ts/routes/inline-video.js')
}

if (document.querySelector('.doc-viewer-close') != null) {
    import('whois-theme/ts/routes/doc-viewer.js')
}

if (document.querySelector('.the-grid') != null) {
    import('whois-theme/ts/routes/thegrid.js')
}

if (document.querySelector('.audio-player,.audio-player-simple') != null) {
    import('whois-theme/ts/routes/audio.js')
}

if (document.querySelector('.audio-swiper') !=null) {
    import('./audio-swiper.js')
}
